import { Link } from "react-router-dom";
import { Phone, Mail, Video, Linkedin, Facebook } from "lucide-react";
import { CONTACT, SIGNATURE } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-deep text-cream">
      <div className="mx-auto max-w-[1500px] px-6 py-20 md:px-12 lg:px-24">
        <div className="grid gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img
                loading="lazy"
                decoding="async"
                src="/images/logo-centre.webp"
                alt="Centre Émergence Prudhomme — Thérapeute | Bien-être et spiritualité Chrétienne"
                data-testid="footer-logo"
                className="h-32 w-auto"
              />
            </div>
            <p className="mt-3 text-xs uppercase tracking-[0.28em] text-cream/50">
              Thérapeute | Bien-être et spiritualité Chrétienne
            </p>
            <p className="mt-8 font-serif text-xl italic text-cream/70">
              {SIGNATURE.join(" • ")}
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-gold">Navigation</p>
            <ul className="mt-6 space-y-3">
              {[
                { to: "/", label: "Accueil" },
                { to: "/services", label: "Services" },
                { to: "/entreprises", label: "Entreprises" },
                { to: "/communaute", label: "Communauté" },
                { to: "/a-propos", label: "À propos" },
                { to: "/ressources", label: "Ressources" },
                { to: "/tarifs", label: "Tarifs" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s|à/g, "-")}`}
                    className="text-cream/70 transition-colors duration-300 hover:text-gold"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.25em] text-gold">Contact</p>
            <ul className="mt-6 space-y-4 text-cream/70">
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-gold" />
                <a href={`tel:${CONTACT.phone.replace(/[^+\d]/g, "")}`} data-testid="footer-phone" className="transition-colors hover:text-gold">
                  {CONTACT.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-gold" />
                <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="transition-colors hover:text-gold">
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Linkedin className="h-4 w-4 text-gold" />
                <a
                  href={CONTACT.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-linkedin"
                  className="transition-colors hover:text-gold"
                >
                  LinkedIn — Jane Prudhomme
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Facebook className="h-4 w-4 text-gold" />
                <a
                  href={CONTACT.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-facebook"
                  className="transition-colors hover:text-gold"
                >
                  Facebook — Émergence Prudhomme
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Video className="h-4 w-4 text-gold" />
                <span>{CONTACT.location}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col gap-3 border-t border-cream/10 pt-8 text-xs text-cream/40 md:flex-row md:items-center md:justify-between">
          <p>© 2026 Centre Émergence Prudhomme — Jane Prudhomme. Tous droits réservés.</p>
          <p>Tous les échanges sont strictement confidentiels.</p>
          <Link to="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-gold">
            Espace professionnel
          </Link>
        </div>
      </div>
    </footer>
  );
}
